// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  assembleQuery,
  fetchContactsByQuery,
} from 'helpers/api'

// searches for contacts that are LIKE in contact code value

const getContactOptions = ({ value }) => {
  const query = [{
    field: 'search',
    value: [[{
      field: 'serviceContactCode',
      operator: 'LIKE',
      value,
    }]],
  }]

  return fetchContactsByQuery(assembleQuery(query))
}

export default getContactOptions
